const BaseView = require('components-framework/view/base.view');
const withProps = require('components-framework/view/with_props');
const {queue, UPDATED} = require('./queue');

module.exports = withProps(BaseView.extend({
    initialize() {
        queue.on(UPDATED, this.render, this);
    },

    render() {
        this.clearNotifications();
        queue.getNotifications().forEach((notification, index, notificationList) => {
            notification.isLastNotification = (index === notificationList.length - 1);
            this.renderNotification(notification);
        });
    },

    renderNotification(data) {
        const elem = this.templates.notificationCard({
            ...data,
            templates: this.templates,
        });
        this.$el.append(elem);
        const $notification = this.$el.find(`.notification-id-${data.id}`);
        if (data.options && data.options.hasCTA) {
            $notification.find('.notification_cta').off().on('click', data.ctaHandler || Function.prototype);
        }
        if (data.options && data.options.hasCloseIcon) {
            $notification.find('.notification_close').off().on('click', data.closeHandler || queue.deleteNotification.bind(queue, data.id));
        }
    },

    clearNotifications() {
        this.$el.empty();
    },
}));
